// Summary: This file exports the dataContext object which is used to store the data from the API call.


// importing dependencies
import {createContext} from 'react';

// exporting the dataContext object
export const dataContext = createContext([]);